module.exports = __webpack_public_path__ + "static/media/arrow-left.a4fbc494.svg";